module.exports = __webpack_public_path__ + "img/marker-orange.93e12324.svg";